import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
// import useUnsavedChangesStore from "@/utils/UnsavedChangesStore";

interface Props {
  showUnsavedDialog: boolean;
  setShowUnsavedDialog: (value: boolean) => void;
  confirmNavigation: () => void;
  cancelNavigation: () => void;
  discardChanges: () => void;
}

export const UnsavedChangesDialog: React.FC<Props> = ({
  showUnsavedDialog,
  setShowUnsavedDialog,
  confirmNavigation,
  cancelNavigation,
  discardChanges,
}) => {
  // const {
  //   showUnsavedDialog,
  //   setShowUnsavedDialog,
  //   confirmNavigation,
  //   cancelNavigation,
  //   discardChanges,
  // } = useUnsavedChangesStore();

  return (
    <Dialog open={showUnsavedDialog} onOpenChange={setShowUnsavedDialog}>
      <DialogContent className="dark:bg-gray-800 dark:text-white min-w-[540px]">
        <DialogHeader>
          <DialogTitle>Unsaved Changes</DialogTitle>
          <DialogDescription className="dark:text-gray-300">
            You have unsaved changes in your template. What would you like to
            do?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex justify-between mt-4">
          <Button
            variant="outline"
            onClick={cancelNavigation}
            className="dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600"
          >
            Continue Editing
          </Button>
          <Button
            variant="destructive"
            onClick={discardChanges}
            className="bg-red-600 hover:bg-red-700 dark:bg-red-700 dark:hover:bg-red-600"
          >
            Discard and Continue
          </Button>
          <Button
            onClick={confirmNavigation}
            className="bg-sky-800 hover:bg-sky-600 text-white"
          >
            Save and Continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UnsavedChangesDialog;
